var colors = {
    // -- primary colors -- //
    plum: '#650360',
    white: '#FFFFFF',
    'page-gray': '#F2F2F2',
    'slate-1': '#E5E5E5',
    'slate-5': '#2A2A2A',
    black: '#000000',
    // -- secondary colors -- //
    'patina-1': '#E7F6FD',
    'patina-2': '#D7E4EB',
    'patina-3': '#C0D0D8',
    'sky-2': '#3798C7',
    sand: '#E8D4A3',
    'light-gray': '#F8F8F8',
    'slate-2': '#DDDDDD',
    'slate-3': '#959595',
    'slate-4': '#666666',
    'slate-8': '#BBBBBB',
    'grey-80': '#CCCCCC',
    'yacht-rock': '#E3ECF1',
    // -- anomaly marketing colors -- //
    blueberry: '#371447',
    champagne: '#FAF3EC',
    grapefruit: '#CE477E',
    grape: '#8A3575',
    seafoam: '#1C988A',
    bluesuedeshoes: '#0071C4',
    // -- tertiary colors -- //
    toaster: '#008486',
    error: '#D42825',
    success: '#0B8100',
    'field-focus': '#FFFFE7',
    'sky-4': '#0079B3',
    'sky-3': '#006899',
    'sky-1': '#8BD3F5',
    warning: '#FFC107',
    // -- account colors -- //
    ira: '#FF5722',
    cda: '#9C27B0',
    dda: '#03A9F4',
    cc: '#FFC107',
    sda: '#3F51B5',
    cmg: '#3F51B5',
    mma: '#3F51B5',
    inv: '#009688',
    inva: '#65C6BB',
    invw: '#6E8FAA',
    auto: '#5E7B87',
    dealer: '#424E61',
    external: '#666666',
    // -- accessible account colors -- //
    'a11y-cmg': '#5A822B',
    'a11y-inv': '#008577',
    'a11y-dda': '#027DB6',
    'a11y-auto': '#5E7B87',
    'a11y-dealer': '#424E61',
};
export default colors;
//# sourceMappingURL=colors.js.map